import { canCreateOrUpdate } from './validators/functions/can-create-or-update.function';

export * from './dtos/create-filebox.dto';
export * from './dtos/filebox-list.dto';
export * from './dtos/filebox-record.dto';
export * from './dtos/filebox-search.dto';
export * from './dtos/filebox-stats.dto';
export * from './dtos/lease-filebox-record.dto';
export * from './dtos/release-filebox-record.dto';
export * from './dtos/renew-filebox-record.dto';
export * from './dtos/update-filebox.dto';

export * from './enums/filebox-operation.enum';
export * from './enums/filebox-status.enum';

export * from './functions/filebox-status-to-color.function';

export * from './types/filebox-filters';
export * from './types/lease-filebox-records-request';
export * from './types/lease-filebox-records-response';
export * from './types/release-filebox-records-request';
export * from './types/renew-filebox-records-request';
export * from './types/renew-filebox-records-response';

export * from './validators/schemas/create-filebox.schema';
export * from './validators/schemas/lease-filebox.schema';
export * from './validators/schemas/release-filebox.schema';
export * from './validators/schemas/renew-filebox.schema';
export * from './validators/schemas/update-filebox.schema';

export const fileboxValidators = {
	canCreateOrUpdate,
};
